import { get } from 'lodash/fp';
import axios from './axios';
import config from '../../helpers/config';

export default (designId, sourceId, targets) => (
  axios.post(
    `${config.designBuilderLoadDesignPath}/${designId}/items/${sourceId}/cloneStyle`,
    { ids: targets },
  )
    .then(get('data'))
);
